export const Logo = ({ className = "w-8 h-8" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <defs>
                <linearGradient id="brand-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#06b6d4" />
                    <stop offset="100%" stopColor="#d946ef" />
                </linearGradient>
            </defs>
            <rect
                x="5"
                y="2"
                width="14"
                height="20"
                rx="2"
                ry="2"
                stroke="url(#brand-gradient)"
            />
            <path d="M12 18h.01" stroke="url(#brand-gradient)" />
        </svg>
    );
};
